module.exports = __webpack_public_path__ + "img/wd-light.521fe004.svg";